export const GetGlobalColor = () => {
    return localStorage.getItem('colorScheme');

};





